import {tint} from 'polished'
import {theme} from 'src/themes'
import {createGlobalStyle} from 'styled-components'
import {palette} from 'styled-tools'

export const ResetStyle = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/
    v2.0 | 20110126
    License: none (public domain)
  */

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  html {
    height: -webkit-fill-available;
  }
  body {
    line-height: 1;
    min-height: -webkit-fill-available;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`

export const GlobalStyle = createGlobalStyle`
  html {
    font-size: 16px;
    color: #011627;
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  body {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: "Inter", sans-serif;
  }
  input {
    font-family: "Inter", sans-serif;
  }
  textarea {
    font-family: "Inter", sans-serif;
  }
  strong, b {
    font-weight: 700;
  }
  i {
    font-style: italic;
  }
  a {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
  }
  link {
    cursor: pointer;
  }

  /* Notification Toasts */
  .Toastify__toast-container {

  }

  /* Notification Toasts */
  .Toastify__toast-container--top-right {
    top: 55px;

    @media(min-width: 1024px) {
      top: 96px;
      right: 16px;
    }
  }

  /** Classes for the displayed toast **/
  .Toastify__toast {
    background-color: white;
    box-shadow: ${tint(0.1, theme.palette.secondary)};
    border: 1px solid ${palette('secondary')};
  }
  .Toastify__toast--success {
    background-color: ${tint(0.9, theme.palette.success)};
    border: 1px solid ${palette('success')};
    .Toastify__toast-body {
      color: ${palette('success')};
    }
    .Toastify__close-button > svg {
    color: ${palette('success')};
  }
  }
  .Toastify__toast--warning {
    background-color: ${tint(0.9, theme.palette.warning)};
    border: 1px solid ${palette('warning')};
    .Toastify__toast-body {
      color: ${palette('warning')};
    }
    .Toastify__close-button > svg {
    color: ${palette('warning')};
  }
  }
  .Toastify__toast--error {
    background-color: ${tint(0.9, theme.palette.error)};
    border: 1px solid ${palette('error')};
    .Toastify__toast-body {
      color: ${palette('error')};
    }
    .Toastify__close-button > svg {
    color: ${palette('error')};
  }
  }
  .Toastify__toast-body {
    font-family: "Inter", sans-serif;
    color: ${palette('secondary')};
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
  }
  .Toastify__close-button > svg {
    color: ${palette('secondary')};
  }
  .Toastify__progress-bar--success {
    background-color: ${palette('success')};
  }
  .Toastify__progress-bar--warning {
    background-color: ${palette('warning')};
  }
  .Toastify__progress-bar--error {
    background-color: ${palette('error')};
  }
`
